import { ReporterService, ReportPageDto, ReportDto, SortOrder, IReportDto, ModifiedReportDto } from "../services/reporter.service";
import { IReportEntries } from "../contracts/IReportEntries";
import oauthFetch from "../helpers/oauth_fetch";
import * as reportConstants from "../constants/report.constants";
import { IReportFilters, TimePeriod } from 'src/contracts/IReportFilters';
import { IRootState } from 'src/reducers';
import { IReportSorting } from 'src/contracts/IReportSorting';
import { ILocalizedError, LocalizeMessage } from "../i18n/error-localization";

export const reportChangeSortAction = (
  sort: IReportSorting) => 
    (dispatch: any, getState: () => IRootState) => {
      dispatch(reportRequestInitiated());

      const { currentPage: page, pageSize } = getState().reports;
      const { startDate, endDate, searchString, timePeriod } = (getState().reports.filters as IReportFilters);
      
      loadReport(page, pageSize, searchString, startDate, endDate, timePeriod, sort.sortBy, sort.order)
      .then(reportEntries => {
        dispatch(reportRequestCompleted(reportEntries));
      })
      .catch(error => {
        dispatch(reportRequestFailed(LocalizeMessage(error)))
      })
}

export const reportChangeFilterAction = (
  filters: IReportFilters) => 
    (dispatch: any, getState: () => IRootState) => {
      dispatch(reportRequestInitiated());

      const { currentPage: page, pageSize } = getState().reports;
      const { startDate, endDate, searchString, timePeriod } = (filters as IReportFilters);

      let sortBy: string | undefined
      let order: SortOrder | undefined

      if (getState().reports.sort !== null) {
        sortBy = getState().reports.sort!.sortBy
        order = getState().reports.sort!.order
      }
      
      loadReport(page, pageSize, searchString, startDate, endDate, timePeriod, sortBy, order)
      .then(reportEntries => {
        dispatch(reportRequestCompleted(reportEntries));
      })
      .catch(error => {
        dispatch(reportRequestFailed(LocalizeMessage(error)))
      })
}

export const reportChangePageAction = (
  page: number,
  pageSize: number,
  history: any) =>
    (dispatch: any, getState: () => IRootState) => {
      dispatch(reportRequestInitiated());

      const { startDate, endDate, searchString, timePeriod } = (getState().reports.filters as IReportFilters);

      let sortBy: string | undefined
      let order: SortOrder | undefined

      if (getState().reports.sort !== null) {
        sortBy = getState().reports.sort!.sortBy
        order = getState().reports.sort!.order
      }

      loadReport(page, pageSize, searchString, startDate, endDate, timePeriod, sortBy, order)
      .then(reportEntries => {
        dispatch(reportRequestCompleted(reportEntries));
      })
      .catch(error => {
        dispatch(reportRequestFailed(LocalizeMessage(error)))
      })
}

const loadReport = (
  page: number,
  pageSize: number,
  searchString: string | undefined,
  startDate: Date | undefined,
  endDate: Date | undefined,
  timePeriod: TimePeriod,
  sortBy: string | undefined,
  order: SortOrder | undefined): Promise<IReportEntries> => {
  const reportEndpoint = `${process.env.REACT_APP_REPORT_SERVICE_ENDPOINT}`;
  const reportService = new ReporterService(reportEndpoint, { fetch: oauthFetch });

  return reportService
    .getReports(page, pageSize, searchString, startDate, endDate, sortBy, order)
    .then((response: ReportPageDto) => {
      const reportEntries: IReportEntries = {
        currentPage: response.pagination!.page,
        entities: response.data as ReportDto[],
        error: null,
        filters: { startDate, endDate, searchString, timePeriod },
        isLoading: false,
        pageSize: response.pagination!.pageSize,
        sort: { sortBy, order },
        totalPages: response.pagination!.totalPages
      };
      return reportEntries
    })
}

export const reportUpdateAction = (report: ModifiedReportDto) => 
    (dispatch: any) => {

    const reportEndpoint = `${process.env.REACT_APP_REPORT_SERVICE_ENDPOINT}`;
    const reportService = new ReporterService(reportEndpoint, { fetch: oauthFetch });

      dispatch(reportRequestInitiated());

      reportService.updateReport(report).then(response => {
          dispatch(reportUpdateCompleted(response!));
      })
      .catch(error => {
        dispatch(reportRequestFailed(LocalizeMessage(error)))
      })
}

export interface IReportRequest {
  type: reportConstants.REPORT_REQUEST;
  payload: {
    isLoading: boolean;
  };
}

export interface IReportSuccess {
  type: reportConstants.REPORT_SUCCESS;
  payload: IReportEntries;
}

export interface IReportFailure {
  type: reportConstants.REPORT_FAILURE;
  payload: ILocalizedError;
}

export interface IReportUpdateSuccess {
  type: reportConstants.REPORT_UPDATE_SUCCESS;
  payload: IReportDto;
}

export type ReportAction = IReportRequest | IReportSuccess | IReportFailure | IReportUpdateSuccess;

const reportRequestInitiated = (): IReportRequest => ({
  payload: { isLoading: true },
  type: reportConstants.REPORT_REQUEST
});

const reportRequestCompleted = (reportEntries: IReportEntries): IReportSuccess => ({
  payload: reportEntries,
  type: reportConstants.REPORT_SUCCESS
});

const reportRequestFailed = (error: ILocalizedError): IReportFailure => ({
  payload: error,
  type: reportConstants.REPORT_FAILURE
});

const reportUpdateCompleted = (updatedReport: IReportDto): IReportUpdateSuccess => ({
  payload: updatedReport,
  type: reportConstants.REPORT_UPDATE_SUCCESS
});


export const reportActions = {
  reportChangePageAction
};



// WEBPACK FOOTER //
// ./src/actions/wipereport.actions.ts